var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "handover-schedule-edit" },
    [
      _c(
        "Sticky",
        {
          staticClass: "stick-btnGroup",
          attrs: {
            extendStickyClass: "stickyBtnClass",
            fullWidth: false,
            align: "right",
          },
        },
        [
          _c("div", { staticClass: "btnGroup" }, [
            !_vm.isEditing && _vm.allowGeneratePdf
              ? _c(
                  "button",
                  {
                    staticClass: "btn--darkblue generatePDF",
                    on: { click: _vm.generatePDF },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.generatePDF")))]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEditing && _vm.allowEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn--orange edit",
                    on: { click: _vm.triggerEditStatus },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing && _vm.allowEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn--darkblue cancel",
                    on: { click: _vm.cancel },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing && _vm.allowEdit
              ? _c(
                  "button",
                  { staticClass: "btn--orange save", on: { click: _vm.save } },
                  [_vm._v(_vm._s(_vm.$t("action.save")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing && _vm.allowEdit && _vm.isHandover
              ? _c(
                  "button",
                  {
                    staticClass: "btn--orange importTemplate",
                    on: { click: _vm.openModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("handover.import")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing && _vm.allowEdit
              ? _c(
                  "button",
                  { staticClass: "btn--orange add", on: { click: _vm.add } },
                  [_vm._v(_vm._s(_vm.$t("action.add")))]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "des-header" }, [
        _c("div", { staticClass: "condition" }, [
          _c("div", { staticClass: "condition-title" }, [
            _vm._v(
              _vm._s(
                _vm.$t("terms." + _vm.regionName + ".hotb.conditionOfPremises")
              )
            ),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "des" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "terms." +
                    _vm.regionName +
                    ".hotb.conditionOfPremisesDes." +
                    _vm.hotbType
                )
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.isHandover
        ? _c("UploadPhotoArea", {
            attrs: {
              uploadSuccess: _vm.uploadSuccess,
              photoesInfo: _vm.schedulesList,
              selectEditPhotoInfo: _vm.selectEditPhotoInfo,
              isEditing: _vm.isEditing,
              allowEdit: _vm.allowEdit,
              updatePhotoInfo: _vm.updatePhotoInfo,
              deleteOnePhoto: _vm.deleteOnePhoto,
              beforeUpload: _vm.beforeUpload,
              deleteOnePhotoInfo: _vm.deleteOnePhotoInfo,
              onDragEnd: _vm.dragEnd,
            },
          })
        : _c(
            "div",
            { staticClass: "takeback-schedule" },
            _vm._l(_vm.schedulesList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "inputGroupItem" },
                [
                  _c(
                    "div",
                    { staticClass: "facility" },
                    [
                      _c("span", { staticClass: "index" }, [
                        _vm._v(_vm._s(index + 1) + ". "),
                      ]),
                      _vm._v(" "),
                      _c("InputField", {
                        staticClass: "facility-input",
                        attrs: {
                          readonly: !_vm.isEditing,
                          showColon: false,
                          value: item.facility || "",
                          required: "",
                        },
                        on: {
                          updateValue: function (val) {
                            return _vm.updatePhotoInfo("facility", index, val)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.isEditing
                        ? _c("i", {
                            staticClass: "fa fa-times",
                            on: {
                              click: function ($event) {
                                return _vm.deleteOnePhotoInfo(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("TextField", {
                    staticClass: "description",
                    attrs: {
                      readonly: !_vm.isEditing,
                      showColon: false,
                      value: item.description
                        ? item.description
                        : !_vm.isEditing
                        ? "N/A"
                        : "",
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updatePhotoInfo("description", index, val)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
      _vm._v(" "),
      _c("RemarksList", {
        ref: "remarksList",
        attrs: { allowEdit: _vm.allowEdit },
      }),
      _vm._v(" "),
      _c("HotbScheduleSignature", {
        ref: "signatureRef",
        attrs: {
          editStatus: _vm.isEditing,
          transactionTime: _vm.transactionTime,
        },
      }),
      _vm._v(" "),
      !_vm.schedulesList.length
        ? _c("div", { staticClass: "empty-schedule" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.isEditing
                    ? _vm.$t("handoverTakebackSchedule.addNewSchedule")
                    : _vm.$t("handoverTakebackSchedule.noSchedule")
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "chooseTemplatesModal",
          staticClass: "choose-template-modal",
          attrs: { modalId: _vm.modalId, showBtns: true },
        },
        [
          _c(
            "p",
            {
              staticClass: "font-bold",
              attrs: { slot: "modal-header" },
              slot: "modal-header",
            },
            [_vm._v(_vm._s(_vm.$t("hint.chooseTemplate")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("HKLSelect", {
                attrs: {
                  value: _vm.choosedTemplate || undefined,
                  options: _vm.templateHklOptions,
                  placeholder: "",
                },
                on: { change: _vm.chooseOneTemplate },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: { click: _vm.closeModal },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: { click: _vm.importTemplate },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }